<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('foorter.video')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <div class="hero-badge">{{ $t("foorter.video") }}</div>
        <div class="hero-title">{{ $t("foorter.video") }}</div>
        <div class="hero-desc">{{ gameitem.length }} {{ $t("index.Entrance") }}</div>
      </div>

      <div class="filter-card">
        <div
          v-for="(item, index) in filterOptions"
          :key="item.key"
          class="filter-pill"
          :class="{ active: activeKey === index }"
          @click="onChange(index)"
        >
          {{ item.name }}
        </div>
      </div>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty
          v-if="gameitem.length === 0"
          :description="$t('withdraw.empty_data')"
        />

        <div v-else class="game-list">
          <div
            v-for="(v, key) in gameitem"
            :key="key"
            class="game-card"
            @click="toLottery(v.key, v.id)"
          >
            <div class="game-card-top">
              <div class="game-icon-wrap">
                <img
                  :src="getGameIcon(v, key)"
                  class="game-icon"
                  alt=""
                  @error="onGameIconError($event, key)"
                />
              </div>
              <div class="game-arrow">></div>
            </div>

            <div class="game-name">{{ formatGameName(v.name) || "-" }}</div>
            <div class="game-desc">
              {{ formatGameDesc(v.desc) || $t("index.Entrance") }}
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      gameitem: [],
      lotteryitem: [],
      isLoading: false,
      activeKey: 0,
    };
  },
  computed: {
    filterOptions() {
      return [{ key: "all", name: this.$t("index.all") }].concat(
        Array.isArray(this.lotteryitem) ? this.lotteryitem : []
      );
    },
  },
  methods: {
    formatGameName(name) {
      return String(name || "").replace(/投注入口/g, "遊戲入口");
    },
    formatGameDesc(desc) {
      return String(desc || "").replace(/快速进入页面/g, "快速進入頁面");
    },
    localGameIcons() {
      return [
        require("@/assets/bc-img/meigui.png"),
        require("@/assets/bc-img/baihe.png"),
        require("@/assets/bc-img/yanhua.png"),
        require("@/assets/bc-img/qiqiu.png"),
      ];
    },
    getGameIcon(item, index) {
      return item.ico || this.localGameIcons()[index % this.localGameIcons().length];
    },
    onGameIconError(event, index) {
      event.target.src = this.localGameIcons()[index % this.localGameIcons().length];
    },
    back() {
      this.$router.go(-1);
    },
    async onRefresh() {
      try {
        await Promise.all([this.getLotteryItem(), this.fetchGameListByActive()]);
        Toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        if (!id) return;
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
    fetchGameListByActive() {
      if (this.activeKey === 0) {
        return this.getGameItem();
      }
      return this.$http({
        method: "get",
        data: { class: this.activeKey },
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
    onChange(index) {
      this.activeKey = index;
      return this.fetchGameListByActive();
    },
    getLotteryItem() {
      return this.$http({
        method: "get",
        url: "lottery_class",
      }).then((res) => {
        this.lotteryitem = Array.isArray(res.data) ? res.data : [];
        return res;
      });
    },
  },
  created() {
    Promise.all([this.getLotteryItem(), this.getGameItem()]);
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: #0b0b0d;
}

.content {
  padding: 16px;
  padding-bottom: 90px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  color: #ddd;
  font-size: 24px;
}

.filter-card {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 4px 0 12px;
  margin-bottom: 8px;
  scrollbar-width: none;
}

.filter-card::-webkit-scrollbar {
  display: none;
}

.filter-pill {
  flex-shrink: 0;
  padding: 10px 16px;
  border-radius: 999px;
  border: 1px solid #2f2f35;
  background: #141419;
  color: #8f93a1;
  font-size: 24px;
}

.filter-pill.active {
  color: #111;
  border-color: transparent;
  background: linear-gradient(to right, #f4c57d, #f5a452);
}

.game-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.game-card {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.game-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.game-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.game-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.game-icon-fallback {
  color: #f4c57d;
  font-size: 28px;
  font-weight: 700;
}

.game-arrow {
  color: #8f93a1;
  font-size: 26px;
}

.game-name {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
}

.game-desc {
  margin-top: 6px;
  color: #8f93a1;
  font-size: 22px;
  line-height: 1.6;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #fff;
  font-size: 16px;
}

::v-deep .van-empty__description {
  color: #8f93a1;
}
</style>
